import { isFunction } from 'lodash-es';
import str2json from '../utils/str2json';
const delegate = require('delegate');

export default {
  init: function(app) {
    this.app = app;
    this.bindEvents();
    // console.log('common init');
  },

  bindEvents() {
    // Make the entire block clickable
    delegate(
      document.body,
      '.js-clickBlock',
      'click',
      (e) => {
        // If already a link bailout
        if (e.target.tagName == 'A' || e.target.tagName == 'BUTTON') {
          return;
        }

        const link = e.delegateTarget.querySelector('a');
        if (link && link.href) {
          e.preventDefault();
          window.location.href = link.href;
        }
      },
      false
    );

    // Delegate click event for elements that interact with theme components
    delegate(
      document.body,
      '[data-action]',
      'click',
      (e) => {
        e.preventDefault();
        const evData = str2json(e.delegateTarget.dataset.action);
        this.app.emit(evData.type, { identifier: evData.target, initiator: e.delegateTarget });
      },
      false
    );
  }
};

// const delegate = require('delegate');

// const init = (elements) => {
//   window.theme.Components = window.theme.Components || [];

//   elements.forEach((el) => {
//     const modules = el.dataset.component.split(',');
//     modules.forEach((componentConstructor) => {
//       new AppComponents(componentConstructor, el);
//     });
//   });
// };

// // On the first load we load every component
// init(document.querySelectorAll('[data-component]'));
